document.addEventListener('click', function (event) {
  var trigger = event.target.closest('.preorder-status__info');
  if (trigger) {
    var modal = document.getElementById(trigger.getAttribute('aria-controls'));
    if (modal) {
      modal.hidden = false;
      var closeBtn = modal.querySelector('.preorder-status__modal-close');
      if (closeBtn) closeBtn.focus();
    }
    return;
  }

  var closer = event.target.closest('[data-preorder-close]');
  if (closer) {
    var modal = closer.closest('.preorder-status__modal');
    if (modal) modal.hidden = true;
  }
});

document.addEventListener('keydown', function (event) {
  if (event.key === 'Escape') {
    document.querySelectorAll('.preorder-status__modal').forEach(function (modal) {
      if (!modal.hidden) modal.hidden = true;
    });
  }
});